import { render, staticRenderFns } from "./DisplayResponses.vue?vue&type=template&id=8088e014"
import script from "./DisplayResponses.vue?vue&type=script&lang=ts"
export * from "./DisplayResponses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports